import React from 'react';
import {t} from '@lingui/core/macro';

import FiltersModal from 'shared/ui/Modal/FiltersModal/FiltersModal';

import HttpMonitorFiltersFormLog from './HttpMonitorFiltersFormLog';

interface IHttpMonitorFiltersModalLogProps {
    open: boolean,
    handleClose: () => void;
}

const HttpMonitorFiltersModalLog: React.FC<IHttpMonitorFiltersModalLogProps> = ({open, handleClose}) => (
    <FiltersModal header={t`Фильтры`} open={open} handleClose={handleClose}>
        <HttpMonitorFiltersFormLog onSuccess={handleClose} handleClose={handleClose} />
    </FiltersModal>
);

export default HttpMonitorFiltersModalLog;
